import { Component, computed, inject } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import {
  ColumnKey,
  EarnTableState,
  TransactionId,
} from "@bitwarden/web-vault/app/models/types/earn.types";
import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { EarnLookup } from "@bitwarden/web-vault/app/services/earn/lookup.service";

@Component({
  selector: "app-redaction-description-cell-renderer",
  templateUrl: "./description.cell-renderer.html",
})
export class RedactionDescriptionRenderer implements ICellRendererAngularComp {
  value: any;
  params: ICellRendererParams;

  state: EarnTableState;
  shouldMask: boolean;
  isDraft: boolean;
  earnTableService: EarnService = inject(EarnService);
  earnLookup: EarnLookup = inject(EarnLookup);

  isMasked = computed(() =>
    this.earnLookup.isCellMasked(this.params.data?.id, this.params.colDef.field as ColumnKey),
  );

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value;

    this.checkCellVisibility();
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    this.params = params;

    this.checkCellVisibility();
    return true;
  }

  private checkCellVisibility() {
    const rowId: TransactionId = this.params.data?.id;
    const colId: ColumnKey = this.params.colDef.field as ColumnKey;
    if (rowId && colId && this.earnTableService.selectedMask()) {
      this.setCellValue();
    }
  }

  setCellValue() {
    const state = this.earnTableService.breadCrumbState();
    this.isDraft = state === "draft";
    this.shouldMask = !this.isDraft && this.isMasked();

    this.value = this.shouldMask ? "****" : this.params.value;
  }

  toggleCell() {
    const rowId = this.params.data?.id;
    const colId: ColumnKey = this.params.colDef.field as ColumnKey;
    if (rowId && colId) {
      this.earnLookup.toggleCell(rowId, colId);
      return;
    }
  }
}
